export function routes($stateProvider) {
    $stateProvider
        .state('app.gas.oi', {
        url: '/ordens-intervencao',
        abstract: true
    })
        .state('app.gas.oi.list', {
        url: '?{page:int}&{items:int}&{state:int}&order&sort&filter',
        title: 'Ordens de Intervenção',
        template: '<gas-oi-list-view></gas-oi-list-view>',
        role: ['gasOIList'],
        params: {
            state: {
                value: 1,
                dynamic: true
            },
            page: {
                value: 1,
                dynamic: true
            },
            items: {
                value: 20,
                dynamic: true
            },
            order: {
                value: "id",
                dynamic: true
            },
            sort: {
                value: "desc",
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.gas.oi.details', {
        url: '/{id:int}',
        title: 'Detalhes da Ordem de Intervenção',
        template: '<gas-oi-details-view></gas-oi-details-view>',
        role: ['gasOIList'],
    });
}
routes.$inject = ['$stateProvider'];
